<template>
  <div class="marketing-automation-form-panel-email">
    <app-form @submit="setStep">

      <marketing-automation-form-panel-section :title="$t('message.automation.message.setWaitInterval')">
        <div class="marketing-automation-form-panel-email-section-counter-wait">
          <text-field class="marketing-automation-form-panel-email-section-counter-wait-inpt"
                      v-model="form.days"
                      type="number"
                      :hide-details="true"
                      :min="0"></text-field>
          {{$t('message.automation.message.day')}}{{ form.days > 1 || form.days === 0 ? 's' : '' }}
          <text-field class="marketing-automation-form-panel-email-section-counter-wait-inpt"
                      v-model="form.hours"
                      type="number"
                      :hide-details="true"
                      :min="0"></text-field>
            {{$t('message.automation.message.hour')}}{{ form.hours  > 1 || form.hours === 0 ? 's' : '' }}
          <text-field class="marketing-automation-form-panel-email-section-counter-wait-inpt"
                      v-model="form.minutes"
                      type="number"
                      :hide-details="true"
                      :min="0"></text-field>
            {{$t('message.automation.message.minute')}}{{ form.minutes > 1 || form.minutes === 0 ? 's' : '' }}
        </div>

        <marketing-automation-form-panel-timer-hour v-model="form.scheduledHour" />

      </marketing-automation-form-panel-section>

      <marketing-automation-form-panel-section :title="$t('message.automation.message.waitingRules')"
                                               class="marketing-automation-form-panel-email-section-counter-type">
        <div class="marketing-automation-form-panel-email-section-counter-type-item">
          <app-toggle v-model="form.weekendEnabled"></app-toggle>
          <p class="marketing-automation-form-panel-email-section-counter-type-item-text">{{$t('message.automation.message.considerWeekends')}}</p>
        </div>

        <div class="marketing-automation-form-panel-email-section-counter-type-item">
          <app-toggle v-model="form.businessHourEnabled"></app-toggle>
          <p class="marketing-automation-form-panel-email-section-counter-type-item-text">{{$t('message.automation.message.businessHours')}}</p>
        </div>
      </marketing-automation-form-panel-section>

      <marketing-automation-form-panel-section>
        <button class="marketing-automation-form-panel-email-section-action btn btn-round btn-primary"
                type="submit">{{ actionText }}</button>
      </marketing-automation-form-panel-section>
    </app-form>
  </div>
</template>

<script>
import AppToggle from "@components/Toggle";
import TextField from "@components/form/TextField.vue";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import AppForm from "@components/form/Form.vue";
import MarketingAutomationFormPanelTimerHour from "@components/modules/marketing/automation/form/steps/panel/timer/hour/MarketingAutomationFormPanelTimerHour.vue";

export default {
  components: {
    AppForm,
    MarketingAutomationFormPanelSection,
    TextField,
    AppToggle,
    MarketingAutomationFormPanelTimerHour,
  },

  props: {
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      emailOptions: [],
      page: 0,
      filter: undefined,
      infiniteId: +new Date(),
      form: {
        days: 0,
        hours: 0,
        minutes: 0,
        scheduledHour: undefined,
        weekendEnabled: true,
        businessHourEnabled: true,
      },
    };
  },

  created() {
    if (this.step) {
      this.setInitialData();
    }
  },

  computed: {
    actionText() {
      return this.step ? this.$t('message.generics.message.save') : this.$t('message.generics.message.add');
    },
  },

  methods: {
    async setInitialData() {
      this.form = {
        days: this.step.properties.days,
        hours: this.step.properties.hours,
        minutes: this.step.properties.minutes,
        scheduledHour: this.step.properties.scheduledHour,
        weekendEnabled: this.step.properties.weekendEnabled,
        businessHourEnabled: this.step.properties.businessHourEnabled,
      };
    },
    setStep() {
      if (this.step && this.step.id) {
        this.editStep();
      } else {
        this.addStep();
      }
    },
    async addStep() {
      const newStep = await this.$api.marketing.automation.flow.addStep({
        automationId: this.automationId,
        stepType: "TIMER",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          ...this.form,
          scheduledHour: this.form.scheduledHour || null,
        }),
      });

      this.$emit("submit", newStep);
    },
    async editStep() {
      const newStep = await this.$api.marketing.automation.flow.editStep({
        stepId: this.step.id,
        automationId: this.automationId,
        stepType: "TIMER",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          ...this.form,
          scheduledHour: this.form.scheduledHour || null,
        }),
      });

      this.$emit("submit", newStep);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-email {
  .marketing-automation-form-panel-email-section-counter-wait {
    font-weight: 600;
    color: #707070;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 10px;

    .marketing-automation-form-panel-email-section-counter-wait-inpt {
      flex: 0;
      flex-basis: 25px;
      padding: 0 !important;
      margin: 0 7px !important;

      ::v-deep input {
        text-align: center;
      }
    }
  }

  .marketing-automation-form-panel-email-section-counter-type {
    .marketing-automation-form-panel-email-section-counter-type-item {
      display: flex;
      gap: 10px;

      .marketing-automation-form-panel-email-section-counter-type-item-text {
        font-size: 12px;
        color: #707070;
        font-weight: 600;
      }
    }
  }

  .marketing-automation-form-panel-email-section-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
